import axios from "axios";
import { Api } from "../api";
import { User, ObjectStorage } from "@/model"

import AxiosErrorService from "@/service/AxiosErrorService";

const UserRepository = {

    async getUsers () {
        const res = await axios.get(Api.BACKEND_URL + Api.GET_USERS_ACTION).catch((error) => {
            return AxiosErrorService.handleError(error);
        });
        return new ObjectStorage(User.createUsersFromResponse(res)).items;
    },

    /**
     * forgotpassword
     * 
     * @param {string} userData
     * 
     * @returns {Object} server response
     */  
    async forgotPassword(userData : string) {
        const res = await axios.post(Api.BACKEND_URL + Api.FORGOT_PASSWORD, userData).catch((error) => {
            return AxiosErrorService.handleError(error);
        });
        //console.log('forgotpassword', res)
        return res;
    },

     /**
     * resetPassword
     * 
     * @param {string} postData
     * 
     * @returns {Object} server response
     */ 
    async resetPassword(postData: string) {
        const res = await axios.post(Api.BACKEND_URL + Api.RESET_PASSWORD, postData).catch((error) => {
            return AxiosErrorService.handleError(error);
        });
        //console.log('resetpassword', res)
        return res;
    },   

}
export default UserRepository;